import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { WebsocketService } from "../../../websocket.service";
import { AuthService } from "../../../services/auth.service";
import { Subject, Subscription, timer } from "rxjs";

@Component({
	selector: "app-remotebash",
	templateUrl: "./remotebash.component.html",
	styleUrls: ["./remotebash.component.scss"],
})
export class RemotebashComponent implements OnInit {
	@Input() data: any = {};
	public username = null;
	headerText = null;
	isConnected = true;
	is_user_connect = true;

	audioVolume: number | 0 = 70;
	resWidth: number | 0 = 1920;
	resHeight: number | 0 = 1080;
	timeMinutes: number | 0 = 30;

	id_sender = null;
	unit_socket_id = null;
	type_shoot = false;
	current_type_shoot = false;

	actionsAudio: Array<{
		label: string;
		command: string;
		is_audio?: boolean;
	}> = [];
	actionsOther: Array<{
		label: string;
		command: string;
		is_audio?: boolean;
	}> = [];

	private aliveTimeoutSub?: Subscription;
	private destroy$ = new Subject<void>();

	constructor(
		private wsService: WebsocketService,
		private authService: AuthService,
		private cdr: ChangeDetectorRef,
		private ws: WebsocketService,
	) {}

	sendcommand(command: string, msgDisplay: string) {
		if (command) {
			const terminal = document.getElementById("terminal");
			this.wsService.emit("send", {
				clientId: this.data.channel,
				message: command,
			});
			if (terminal) {
				const line = document.createElement("p");
				line.innerHTML = `
                        <span class="text-success">${this.username}@</span>:
                        <span class="text-info">~/Netride</span>$ 
                        <span style="color: #b0b0b0;">${msgDisplay}</span>
                      `;
				terminal.insertBefore(line, terminal.firstChild);

				// Scroll hacia abajo
				terminal.scrollTop = terminal.scrollHeight;
			}

			this.aliveTimeoutSub = timer(90_000).subscribe(() => {
				this.isConnected = false;
				this.cdr.detectChanges();
				console.warn("⏱️ No se recibió respuesta en 90s.");
				this.printMessage(
					"Se excedió el tiempo de espera de respuesta de parte del dispositivo",
				);
			});
		}
	}

	applyVolume(value: number) {
		// valida y envía el comando que uses internamente
		if (value >= 0 && value <= 100) {
			this.sendcommand(
				`VOLUMEN_${value}`,
				`Cambiando el volumen a ${value}`,
			);
		}
	}

	applyResolution(width: number, height: number) {
		this.sendcommand(
			`RES_${width}x${height}`,
			`Cambiando la resolución a ${width}x${height}`,
		);
	}

	applyTypeShoot(type: boolean) {
		if (type != this.current_type_shoot) {
			this.sendcommand(
				`A_TYPESHOOT`,
				`Solicitar cambiar modo de captura`,
			);
		}
	}

	applyTime(value: number) {
		if (value > 0) {
			this.sendcommand(
				`TIME_SHOOT_${value}`,
				`Cambiando el tiempo a ${value} minutos`,
			);
		}
	}

	trackByLabel = (_: number, item: { label: string }) => item.label;

	ngOnInit(): void {
		const all = (this.data?.actions ?? []).map((a) => ({
			...a,
			is_audio: !!a.is_audio,
		}));

		this.actionsOther = all.filter((a) => !a.is_audio);

		this.validateConexion();
		this.validate_data_unit();

		this.headerText = this.data.description ?? this.data.name;

		this.authService.getProfile().subscribe((data) => {
			this.username = data.user.name;
		});

		this.wsService.emit("join", this.data.channel);

		this.wsService
			.listen("message")
			.subscribe(
				(data: { clientId: string; msg: string; senderId: string }) => {
					this.id_sender = data.senderId;
					this.validate_response_unit(data.msg);
				},
			);

		this.wsService.listen("user_disconnected").subscribe((data: any) => {
			console.warn(`⚠️ Usuario desconectado: ${data.socketId}`);
			this.id_sender = data.socketId;
			if (this.unit_socket_id == data.socketId) {
				this.isConnected = false;
				this.cdr.detectChanges();

				this.printMessage("Dispositivo desconectado");
			}
			// aquí puedes actualizar tu lista de usuarios o mostrar una notificación
		});

		this.ws.getConnectionStatus().subscribe((status) => {

			if (status === "connected") {
				this.is_user_connect = true;
				this.cdr.detectChanges();
			}

			if (status === "disconnected") {
				this.is_user_connect = false;
				this.cdr.detectChanges();
			}
		});
	}

	ngOnDestroy(): void {
		this.aliveTimeoutSub?.unsubscribe();
		this.destroy$.next();
		this.destroy$.complete();

		this.wsService.off("message");
		this.wsService.emit("leave_channel", this.data.channel);
		this.wsService.disconnect();

		this.isConnected = false;
		this.username = null;
		this.headerText = null;
		this.actionsAudio = [];
		this.actionsOther = [];
		this.data = {};
	}

	printMessage(msg: string): void {
		const terminal = document.getElementById("terminal");
		let sender = this.data.description;

		if (this.unit_socket_id != this.id_sender) {
			sender = "Usuario Netride";
		}

		if (!terminal) return;

		// 🧩 Dividimos el mensaje en líneas por "\n"
		const lines = msg.split(/\r?\n/);

		// 🔹 Construimos el HTML con todas las líneas, cada una en un <span> o <br>
		const messageHTML = lines
			.map((line) => `<span>${line}</span>`)
			.join("<br>");

		// 🔹 Agregamos todo el bloque como un solo mensaje
		const line = document.createElement("p");
		line.innerHTML = `
			<span class="text-success">${sender}@</span>:
			<span class="text-info">~/Netride</span>$ ${messageHTML}
		`;

		terminal.insertBefore(line, terminal.firstChild);
	}

	validateConexion(): void {
		this.aliveTimeoutSub?.unsubscribe();
		this.aliveTimeoutSub = undefined;

		this.wsService.emit("send", {
			clientId: this.data.channel,
			message: "IS_LIVE",
		});

		this.aliveTimeoutSub = timer(10_000).subscribe(() => {
			this.isConnected = false;
			this.cdr.detectChanges();
			console.warn(
				'⏱️ No se recibió "YU" en 10s. Marcando isConnected = false.',
			);
		});
	}

	validate_response_unit(msg: string): void {
		if (msg.includes("YU")) {
			this.isConnected = true;
			this.unit_socket_id = this.id_sender;

			this.printMessage("Dispositivo encendido");

			this.aliveTimeoutSub?.unsubscribe();
			this.aliveTimeoutSub = undefined;

			// this.cdr.detectChanges();
		} else if (msg.includes("VOLUMEN_ACTUAL")) {
			const parts = msg.split("_");
			this.audioVolume = parseInt(parts[2]) | 0;

			this.printMessage("Volumen obtenido");

			this.aliveTimeoutSub?.unsubscribe();
		} else if (
			msg.includes("VOLUMEN_") &&
			this.unit_socket_id == this.id_sender
		) {
			this.printMessage("Volumen actualizado");
		} else if (msg.includes("RES_")) {
			const [widthStr, heightStr] = msg.split("_")[1].split("x");

			this.resWidth = parseInt(widthStr);
			this.resHeight = parseInt(heightStr);

			this.printMessage("Resolución obtenida");

			this.aliveTimeoutSub?.unsubscribe();
		} else if (msg.includes("DEBUG_")) {
			const [word, value] = msg.split("_");

			if (value == "ON") {
				this.headerText =
					(this.data.description ?? this.data.name) + " (DEBUG)";
			} else if (value == "OFF") {
				this.headerText = this.data.description ?? this.data.name;
			} else if (value == "ACTUALIZADO") {
				this.printMessage("Modo de compilacion actualizado");
			}

			this.aliveTimeoutSub?.unsubscribe();
		} else if (msg.includes("TIEMPO_ACTUAL_")) {
			const parts = msg.split("_");
			this.timeMinutes = parseInt(parts[2]) | 0;

			this.printMessage("Tiempo obtenido");

			this.aliveTimeoutSub?.unsubscribe();
		} else if (msg.includes("TIME_SHOOT_")) {
			this.printMessage("Tiempo actualizado");
		} else if (msg.includes("typeshoot_ACTUALIZADO")) {
			this.current_type_shoot = this.type_shoot;
			this.printMessage("Modo de captura actualizado");
		} else if (msg.includes("SCREENSHOT")) {
			this.type_shoot = false;
			this.current_type_shoot = false;

			this.printMessage("Modo de captura pantalla");
		} else if (msg.includes("CAMARA")) {
			this.type_shoot = true;
			this.current_type_shoot = true;

			this.printMessage("Modo de captura cámara");
		} else {
			this.printMessage(msg);
			if (this.id_sender == this.unit_socket_id)
				this.aliveTimeoutSub?.unsubscribe();
		}
		if (this.id_sender == this.unit_socket_id)
			this.aliveTimeoutSub?.unsubscribe();
		this.cdr.detectChanges();
	}

	validate_data_unit(): void {
		this.wsService.emit("send", {
			clientId: this.data.channel,
			message: "GET_VOLUME",
		});
		this.wsService.emit("send", {
			clientId: this.data.channel,
			message: "GET_RES",
		});
		this.wsService.emit("send", {
			clientId: this.data.channel,
			message: "GET_TIME_SHOOT",
		});
		this.wsService.emit("send", {
			clientId: this.data.channel,
			message: "IS_DEBUG",
		});
		this.wsService.emit("send", {
			clientId: this.data.channel,
			message: "IS_TYPESHOOT",
		});
	}

	async reconect(): Promise<void> {
		const user = JSON.parse(localStorage.getItem("user"));
		try {
			const socketId = await this.ws.connectAndWait({
				identifier: user.id.toString(),
				name: user.name,
			});

			console.log("Socket conectado:", socketId);
		} catch (err) {
			console.error("No se pudo conectar el socket", err);
		}
	}
}
